import React, { useEffect, useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Collapse, Nav, Navbar, NavItem } from 'reactstrap';
import useAuth from '../../../hooks/useAuth';
import { Roles } from '../../../store/Utility/Utility';
import axios from '../../../api/axios';
import { LOGOUT_URL } from '../../../store/Utility/Resource';

const HeaderPrivate = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [visible, setVisible] = useState(false);
    // eslint-disable-next-line no-unused-vars
    const [isCartview, setIsCartview] = useState(false);
    const wrapperRef = useRef(null);
    const { auth, setAuth } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            window.removeEventListener('scroll', handleScroll);
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const toggle = () => {
        setIsOpen(!isOpen);
    };

    const handleClickOutside = (event) => {
        if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
            setIsCartview(false);
        }
    };
    const handleScroll = () => {
        var scrollTop =
            (document.documentElement && document.documentElement.scrollTop) ||
            document.body.scrollTop;
        if (scrollTop > 100) {
            setVisible(true);
        } else {
            setVisible(false);
        }
    };

    const handleLogout = async () => {
        try {
            await axios.post(LOGOUT_URL, {}, { withCredentials: true });
        } catch (err) {
            console.error(err);
        } finally {
            setAuth({});
            navigate('/login', { replace: true });
        }
    }

    return (
        <header id="site-header" className="header" style={{ backgroundColor: "white" }}>
            <div id="header-wrap" className={`${visible ? 'fixed-header ' : ''}`}>
                <div className="container">
                    <div className="row">
                        <div className="col">
                            {/* Navbar */}
                            <Navbar className="navbar navbar-expand-lg navbar-light">
                                <Link className="navbar-brand logo text-primary mb-0" to="/dashboard" style={{ fontFamily: "Inter-SemiBold" }}>
                                    <span className="text-dark font-w-4">inspectiver</span>
                                </Link>
                                <button
                                    className="navbar-toggler"
                                    type="button"
                                    data-toggle="collapse"
                                    data-target="#navbarNavDropdown"
                                    aria-expanded="false"
                                    aria-label="Toggle navigation"
                                    onClick={toggle}
                                >
                                    <span className="navbar-toggler-icon"></span>
                                </button>
                                <Collapse
                                    isOpen={isOpen}
                                    className="collapse navbar-collapse"
                                    navbar
                                >
                                    {auth?.user ?
                                        (<Nav className="mx-auto navbar-nav">
                                            {auth?.user?.roles?.find(role => [Roles.Admin, Roles.BusinessAdmin].includes(role)) && <>
                                                <NavItem>
                                                    <Link className='nav-link' onClick={() => setIsOpen(false)} to="/drafts" >Drafts</Link>
                                                </NavItem>
                                                {/* <NavItem>
                                                    <Link className='nav-link' onClick={() => setIsOpen(false)} to="/inspector-search">Payments</Link>
                                                </NavItem> */}
                                                <NavItem>
                                                    <Link className='nav-link' onClick={() => setIsOpen(false)} to="/orders">Orders</Link>
                                                </NavItem>
                                                <NavItem>
                                                    <Link className='nav-link' onClick={() => setIsOpen(false)} to="/users">Users</Link>
                                                </NavItem>
                                                <NavItem>
                                                    <Link className='nav-link' onClick={() => setIsOpen(false)} to="/profile">Profile</Link>
                                                </NavItem>
                                                <NavItem>
                                                    <Link className='btn btn-primary btn-sm' onClick={() => setIsOpen(false)} to="/new-order"><i className="las la-file-alt la-lg me-1"></i> New Order</Link>
                                                </NavItem>
                                            </>}

                                            {/* {auth?.user?.roles?.find(role => [Roles.VehicleInspector].includes(role)) &&
                                                <>
                                                    <NavItem>
                                                        <Link className='nav-link' onClick={() => setIsOpen(false)} to="/workhub">Workhub</Link>
                                                    </NavItem>
                                                    <NavItem>
                                                        <Link className='nav-link' onClick={() => setIsOpen(false)} to="/training">Training</Link>
                                                    </NavItem>
                                                    <NavItem>
                                                        <Link className='nav-link' onClick={() => setIsOpen(false)} to="/inspector-faqs">FAQs</Link>
                                                    </NavItem>
                                                </>
                                            } */}

                                            {/* {auth?.user?.roles?.find(role => [Roles.Employee, Roles.Admin].includes(role)) &&
                                                <>
                                                    <NavItem>
                                                        <Link className='nav-link' onClick={() => setIsOpen(false)} to="/awaiting-inspector">Inspector Search</Link>
                                                    </NavItem>
                                                </>
                                            } */}
                                        </Nav>) : null}
                                </Collapse>

                                {auth?.user && <div className="d-sm-flex align-items-center justify-content-end">
                                    <ul className="navbar-nav navbar-nav-icons flex-row">
                                        <li className="d-sm-flex nav-item  mb-0 font-w-7o">
                                            <a id="navbarDropdownUser" href="#!" role="button" data-bs-toggle="dropdown" data-bs-auto-close="outside" aria-haspopup="true" aria-expanded="false">
                                                <div className="avatar">
                                                    <div
                                                        className="d-flex align-items-center justify-content-center bg-primary text-white rounded-circle font-weight-bold"
                                                        style={{ width: '50px', height: '50px', fontSize: '20px', fontWeight: 'bold' }}

                                                    >
                                                        {/* <img className="rounded-circle" style={{ width: "40px", height: "40px" }} src={auth?.user?.profile} alt="" /> */}
                                                        {auth?.user?.firstName?.trim()?.charAt(0)} {auth?.user?.lastName?.trim()?.charAt(0)}
                                                    </div>
                                                </div>
                                            </a>
                                            <div className="dropdown-menu dropdown-menu-end navbar-dropdown-caret py-0 dropdown-profile shadow border" aria-labelledby="navbarDropdownUser">
                                                <div className="card position-relative border-0">
                                                    <div className="card-body p-0">
                                                        <div className="text-center pt-4 pb-3">
                                                            <div className="avatar-l">
                                                                <div
                                                                    className="d-flex align-items-center justify-content-center bg-primary text-white rounded-circle font-weight-bold"
                                                                    style={{ width: '60px', height: '60px', fontSize: '24px', fontWeight: 'bold' }}

                                                                >
                                                                    {auth?.user?.firstName?.trim()?.charAt(0)} {auth?.user?.lastName?.trim()?.charAt(0)}
                                                                </div>
                                                            </div>
                                                            <h6 className="mt-2 text-body-emphasis">{auth?.user.firstName} {auth?.user.lastName}</h6>
                                                        </div>
                                                    </div>
                                                    <div className="overflow-auto scrollbar" style={{ height: "10rem" }}>
                                                        <ul className="nav d-flex flex-column mb-2 pb-1">
                                                            <li className="nav-item"><Link className="nav-link px-3" to="/profile">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="16px" height="16px" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-user me-2 text-body"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg><span>Profile</span></Link></li>

                                                            <li className="nav-item"><Link className="nav-link px-3" to="/dashboard">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="16px" height="16px" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-pie-chart me-2 text-body"><path d="M21.21 15.89A10 10 0 1 1 8 2.83"></path><path d="M22 12A10 10 0 0 0 12 2v10z"></path></svg><span>Dashboard</span></Link></li>

                                                        </ul>
                                                    </div>
                                                    <div className="card-footer p-0 border-top border-translucent">
                                                        <div className="px-3 pt-3 pb-1">
                                                            <button className="btn btn-primary w-100" onClick={handleLogout}>
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="16px" height="16px" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-log-out me-2"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path><polyline points="16 17 21 12 16 7"></polyline><line x1="21" y1="12" x2="9" y2="12"></line></svg>
                                                                Sign out</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </li></ul>
                                </div>}
                            </Navbar>
                        </div>
                    </div>
                </div>
            </div>
        </header>
    );
};

export default HeaderPrivate;